import { useContext, useEffect, useState } from 'react';

import { observer } from 'mobx-react-lite';

import Spinner from 'components/common/Spinner/Spinner';
import { RootStoreContext } from 'index';

import PersonalInformation from './PersonalInformation/PersonalInformation';
import AccountSettingsBlock from './AccountSettings/AccountSettings';
import EmailNotifications from './UserEmailNotifications/UserEmailNotifications';
import styles from './MyProfile.module.scss';

const MyProfile = () => {
  const { authStore } = useContext(RootStoreContext);
  const [isAccountLoading, setIsAccountLoading] = useState(true);

  const getAccount = async () => {
    setIsAccountLoading(true);

    try {
      await authStore.getAccount();
    } finally {
      setIsAccountLoading(false);
    }
  };

  useEffect(() => {
    getAccount();
  }, [authStore]);

  return isAccountLoading ? (
    <Spinner />
  ) : (
    <div className={styles.infoContainer}>
      <div className={styles.mainHeader}>My Profile</div>
      <PersonalInformation />
      <AccountSettingsBlock />
      <EmailNotifications />
    </div>
  );
};

export default observer(MyProfile);
